import { Route, Routes } from "react-router-dom";
import { MainLayout } from "../layouts/MainLayout";
import { AdminLayout } from "../layouts/AdminLayout";

//pages
import { Games } from "../pages/Games";
import { Home } from "../pages/Home";
import { Fights } from "../pages/Fights";
import { Leagues } from "../pages/Leagues";
import { Players } from "../pages/Players";
import { Teams } from "../pages/Teams";
import { Game } from "../pages/profiles/Game";
import { Team } from "../pages/profiles/Team";
import { Fight } from "../pages/profiles/Fight";
import { League } from "../pages/profiles/League";
import { Player } from "../pages/profiles/Player";
import { Create } from "../pages/admin/Create";
import { AdminHome } from "../pages/admin/AdminHome";
import { Dashboard } from "../pages/admin/Dashboard";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";

export const HFCRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Home />} />
        <Route path="game/:gameID" element={<Game />} />
        <Route path="games" element={<Games />} />
        <Route path="fight/:fightID" element={<Fight />} />
        <Route path="fights" element={<Fights />} />
        <Route path="league/:leagueID" element={<League />} />
        <Route path="leagues" element={<Leagues />} />
        <Route path="player/:playerID" element={<Player />} />
        <Route path="players" element={<Players />} />
        <Route path="team/:teamID" element={<Team />} />
        <Route path="teams" element={<Teams />} />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminHome />} />
          <Route path="create" element={<Create />} />
          <Route path="dashboard" element={<Dashboard />} />
        </Route>
      </Route>
    </Routes>
  );
};
